import { useEffect, RefObject } from 'react'
export function useSwipeToClose(
  menuRef: RefObject<HTMLDivElement>,
  onClose: () => void,
) {
  useEffect(() => {
    const menu = menuRef.current
    if (!menu) return
    let startX: number
    let currentX: number
    const handleTouchStart = (e: TouchEvent) => {
      startX = e.touches[0].clientX
      currentX = startX
    }
    const handleTouchMove = (e: TouchEvent) => {
      if (startX > 50) return
      currentX = e.touches[0].clientX
      const diff = currentX - startX
      if (diff < 0) return
      menu.style.transform = `translateX(${diff}px)`
    }
    const handleTouchEnd = () => {
      const diff = currentX - startX
      if (diff > 100) {
        onClose()
      }
      menu.style.transform = ''
    }
    menu.addEventListener('touchstart', handleTouchStart)
    menu.addEventListener('touchmove', handleTouchMove)
    menu.addEventListener('touchend', handleTouchEnd)
    return () => {
      menu.removeEventListener('touchstart', handleTouchStart)
      menu.removeEventListener('touchmove', handleTouchMove)
      menu.removeEventListener('touchend', handleTouchEnd)
    }
  }, [menuRef, onClose])
}
